import React, {PropTypes} from 'react';
import {
    buildCurrency,
    buildNumber
} from '../../../../shared/services/build-number';
import {FormattedMessage} from 'react-intl';
import LabeledNode from '../../../../shared/components/labeled-node';
import {Link} from 'react-router';
import LinkOrSpan from '../../../../shared/components/link-or-span';
import RecoveryPercentageIcon from '../recovery-percentage-icon';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const ReimbursementSummaryMainPanel = (props, context) =>
    <section className='reimbursement-summary-main-panel'>
        <span className='title'>{props.title}</span>
        <span className='approved-claim-count'>
            <Link to={`/reimbursement-summary/claims?${props.queryString}`}>
                <FormattedMessage
                    id='CLAIM_COUNT_WITH_PARENTHESIS'
                    values={{
                        count: props.claimCount,
                        countToDisplay: buildNumber(props.claimCount)
                    }}
                />
            </Link>
        </span>
        <Link to={`/reimbursement-summary/details?query=${props.queryId}&${props.queryString}`}>
            <FormattedMessage id='VIEW_DETAILS'/>
        </Link>
        <RecoveryPercentageIcon recoveryPercentage={props.recoveryPercentageForIndicator}/>
        <div className='row'>
            <LabeledNode
                className='recovery'
                data={
                    <FormattedMessage
                        id='PERCENTAGE_SYMBOL'
                        values={{
                            percentage: buildNumber(props.recoveryPercentage)
                        }}
                    />
                }
                label='RECOVERY'
            />
            <LabeledNode
                className='total-unpaid'
                data={
                    <LinkOrSpan
                        actualValue={props.totalUnpaid}
                        displayValue={buildCurrency(props.totalUnpaid, context.user.settings.general.decimalFormat.key)}
                        link={`/reimbursement-summary/claims?${props.queryString}&unpaidFilter=totalUnpaid`}
                    />
                }
                label='TOTAL_UNPAID'
            />
            <span className='sub-panel'>{props.children}</span>
        </div>
    </section>;

ReimbursementSummaryMainPanel.displayName = 'ReimbursementSummaryMainPanel';
ReimbursementSummaryMainPanel.propTypes = {
    children: PropTypes.node,
    claimCount: PropTypes.number.isRequired,
    queryId: PropTypes.string.isRequired,
    queryString: PropTypes.string.isRequired,
    recoveryPercentage: PropTypes.number.isRequired,
    recoveryPercentageForIndicator: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    totalUnpaid: PropTypes.number.isRequired
};
ReimbursementSummaryMainPanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ReimbursementSummaryMainPanel;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/reimbursement-summary-main-panel.js